import { render, staticRenderFns } from "./searchSettled.vue?vue&type=template&id=bf5c4508&scoped=true&"
import script from "./searchSettled.vue?vue&type=script&lang=js&"
export * from "./searchSettled.vue?vue&type=script&lang=js&"
import style0 from "./searchSettled.vue?vue&type=style&index=0&id=bf5c4508&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5c4508",
  null
  
)

export default component.exports